/* unplugin-vue-components disabled */import script from "./relationNetModal.vue?vue&type=script&setup=true&lang=js"
export * from "./relationNetModal.vue?vue&type=script&setup=true&lang=js"

import "./relationNetModal.vue?vue&type=style&index=0&id=3f820354&lang=scss"

const __exports__ = script;

export default __exports__